import { querySite } from 'libs/e1api/autoBrand';
import { BrandColorList } from 'modules/User';
import { toHex } from 'utils/color';

export type AutoBrandEntity = {
  colors: BrandColorList;
  logos: Blob[];
};

/**
 * Helper to parse and normalize data from brand
 * @param brandURL string
 * @returns AutoBrandEntity
 */
export const getAutoBrand = async (brandURL: string): Promise<AutoBrandEntity> => {
  try {
    const { logos, colors } = await querySite(brandURL);
    let logoBlobs: Blob[] = [];
    let palettes: BrandColorList = [];

    if (colors.length === 0 && logos.length === 0) {
      return { logos: [], colors: [] };
    }

    try {
      logoBlobs = await Promise.all(logos.map((logo) => fetch(logo).then((res) => res.blob())));
    } catch (err) {
      console.error(err);
    }

    palettes = colors.map((color) => ({
      color: toHex(`rgb(${color[0]}, ${color[1]}, ${color[2]})`),
      label: '',
    }));

    return { logos: logoBlobs, colors: palettes };
  } catch (error) {
    console.error('getAutoBrand', error);
    return { logos: [], colors: [] };
  }
};
